import { useState } from 'react'
import config from 'src/config'

export const getProductBrandLogoSources = (logo?: string, large = false) => {
  const value = String(logo || '').trim()
  if (!value) return null
  const original = /^https?:\/\//i.test(value) || value.startsWith('/')
    ? value : `${config.image_server}/brand/${value}`
  // These are the existing central brand-logo variants (api-server/src/api.ts).
  // Leave external and nonstandard image names untouched.
  const standard = original.startsWith(`${config.image_server}/brand/`)
    && /-w(?:350|737)\.webp$/i.test(original)
  return {
    original,
    small: standard ? original.replace(/-w\d+\.webp$/i, large ? '-w350.webp' : '-w100.webp') : original,
    highDensity: standard ? (large ? original : original.replace(/-w\d+\.webp$/i, '-w350.webp')) : undefined,
  }
}

const BrandLogo: React.FC<{ logo?: string; title?: string; large?: boolean }> = ({ logo, title, large = false }) => {
  const sources = getProductBrandLogoSources(logo, large)
  const [failedSource, setFailedSource] = useState('')
  if (!sources) return null
  const useOriginal = failedSource === sources.original

  return <picture>
    {!useOriginal && sources.highDensity && (
      <source media='(min-resolution: 1.5dppx)' srcSet={sources.highDensity} />
    )}
    <img
      src={useOriginal ? sources.original : sources.small}
      alt={title || ''}
      width={large ? 350 : 86}
      height={large ? 64 : 34}
      loading={large ? 'lazy' : undefined}
      decoding='async'
      onError={() => { if (!useOriginal) setFailedSource(sources.original) }}
    />
  </picture>
}

export default BrandLogo
